export default "__VITE_ASSET__2a31827e__"